import React from 'react'

import Layout from '../components/layout'
import TestimonialSlider from '../components/homepage-carousel'
import FeatureViewer from '../components/feature-viewer'

import bannerPhones from '../images/banner-phones.svg'
import bannerPhonesMobile from '../images/banner-phones-mobile.png'
import introImage from '../images/CTA-image.png'
import introImageMobile from '../images/introduction-mobile.png'
import taxIconMobile from '../images/tax-icon-mobile.png'
import shopIconMobile from '../images/shop-icon-mobile.png'
import paperworkIconMobile from '../images/paperwork-icon-mobile.png'
import downloadIcon from '../images/download-icon.svg'

const IndexPage = () => {
  return (
    <Layout>
      <div className="section section--banner">
        <div className="section__inner">
          <div className="section__half section__half--left">
            <h1>Tax Free шопинг в твоем смартфоне</h1>
            <a href="#footer-links" className="button button--icon"><img className="homepage-icon" src={downloadIcon} alt="Easy to use" />Скачать</a>
          </div>
          <div className="section__half section__half--right">
            <img className="image--desktop" src={bannerPhones} alt="Airvat Phone Demo" />
            <img className="image--mobile" src={bannerPhonesMobile} alt="Airvat Phone Demo" />
          </div>
        </div>
      </div>
      <div className="section section--introduction">
        <div className="section__inner">
          <div className="section__half introduction--left">
            <img className="image--desktop" src={introImage} alt="Easy to use" />
            <img className="image--mobile" src={introImageMobile} alt="Easy to use" />
          </div>
          <div className="section__half introduction--right">
            <div className="introduction__content">
              <h2 className="gradient-bg">С нами Tax Free шопинг в Великобритании проще и дешевле!</h2>
              <div className="introduction__point">
                <img src={taxIconMobile} alt="Tax" className="mobile-icon" />
                <h3>ВЕРНИТЕ БОЛЬШЕ НДС С НАШИМ ПРИЛОЖЕНИЕМ</h3>
                <p className="large">Tax Free агенты, с которыми сотрудничают магазины обычно берут себе до 50% от суммы НДС в виде комиссий, сборов и невыгодного курса обмена валюты. Наши услуги гораздо дешевле, а значит, Ваш возврат больше!</p>
              </div>
              <div className="introduction__point">
                <img src={shopIconMobile} alt="Tax" className="mobile-icon" />
                <h3>TAX FREE В ЛЮБОМ МАГАЗИНЕ</h3>
                <p className="large">Используйте наше приложение в любом магазине Великобритании. Вы получите единый tax free сервис независимо от того, где Вы делаете покупки - в бутике класса «люкс» или небольшой сувенирной лавке!</p>
              </div>
              <div className="introduction__point">
                <img src={paperworkIconMobile} alt="Tax" className="mobile-icon" />
                <h3>ЗАБУДЬТЕ ОБ УТОМИТЕЛЬНОМ ЗАПОЛНЕНИИ TAX FREE ФОРМ - МЫ ВСЕ СДЕЛАЕМ ЗА ВАС!</h3>
                <p className="large">Вам больше не нужно заполнять многочисленные Tax Free формы из разных магазинов вручную. Мы оформим все Ваши чеки в единую Tax Free форму для возврата НДС.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section section--features">
        <div className="section__inner">
          <FeatureViewer></FeatureViewer>
        </div>
      </div>
      <div className="section section--testimonials">
        <div className="section__inner">
          <h2 className="gradient-bg">Отзывы о нашей работе</h2>
          <TestimonialSlider></TestimonialSlider>
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage